export default "__VITE_ASSET__BMnWTS_a__"